<template>
  <form @input="$emit('input', formattedLetterWords)">
    <div v-for="(item, i) in letterWords" :key="i">
      <div v-for="(inner, j) in item" :key="j">
        <input type="text" v-model="inner.word" placeholder="Word" />
        <input type="text" v-model="inner.src" placeholder="Audio link" />
      </div>

      <button type="button" @click="addInner(item)">
        + Add
      </button>

      <button type="button" @click="copyItem(item)" class="ml-10">
        ][ Copy
      </button>
    </div>

    <hr v-if="letterWords.length > 0">

    <button type="button" @click="addItem">
      + Add Item
    </button>
  </form>
</template>

<script>
// "letterWords": [
// [
//   {
//     "word": "baby",
//     "src": "/lesson8/baby.mp3"
//   },
// ]
// ]

export default {
  name: 'Type9b',
  data() {
    return {
      letterWords: [
        [
          {
            word: '',
            src: '',
          },
        ],
      ],
    };
  },
  computed: {
    formattedLetterWords() {
      let result = JSON.parse(JSON.stringify(this.letterWords));

      return result;
    },
  },
  methods: {
    addItem() {
      this.letterWords.push([
        {
          word: '',
          src: '',
        },
      ]);
    },
    addInner(inner) {
      inner.push({
        word: '',
        src: '',
      });
    },
    copyItem(item) {
      item.push(Object.assign({}, item[item.length - 1]));
      this.$emit('input', this.formattedLetterWords)
    },
  },
};
</script>
